{
  "theme": {
    "dark": "Tema oscuro",
    "main": "Tema principal"
  },
  "projectCustomisation": {
    "projectDetails": "Detalles del proyecto",
    "editDetails": "Editar detalles",
    "projectName": "Nombre del proyecto",
    "projectNameHelperText": "Máximo 24 caracteres",
    "projectLogoTitle": "Logotipo del proyecto",
    "projectLogoHint": "Esta imagen se mostrará en la barra de navegación superior y en la página de inicio de sesión del proyecto",
    "projectLogoRemoveTitle": "Elimine la imagen del logotipo de este proyecto",
    "projectLogoRemoveText": "Esto eliminará el archivo de imagen del logotipo y todas las personas que tengan acceso al proyecto dejarán de verlo. ¿Está seguro de que desea continuar?",
    "projectLogoRestrictionHint": "El tamaño máximo de la imagen es de 1920 px (altura) y 1080 px (ancho)",
    "projectImageTitle": "Imagen del proyecto",
    "projectImageHint": "Esta imagen se mostrará en la tarjeta del proyecto y en el panel de control",
    "projectImageRemoveTitle": "Eliminar la imagen de este proyecto",
    "projectImageRemoveText": "Esto eliminará el archivo de imagen y todos los que tengan acceso al proyecto dejarán de verlo. ¿Está seguro de que desea continuar?",
    "projectImageRestrictionHint": "El tamaño máximo de la imagen es de 1920 px (altura) y 1080 px (ancho)"
  },
  "scheduleConfig": {
    "title": "Configuración del cronograma",
    "description": "La programación se puede configurar mediante los siguientes ajustes. Solo haga cambios aquí si tiene un conocimiento detallado de cómo funciona la configuración del cronograma. Si no está seguro, póngase en contacto con el servicio de asistencia de Iventis:",
    "save": "Guarda los cambios de horario",
    "timesAndDates": "Horas y fechas",
    "venueTypeHierarchy": "Jerarquía de tipos de lugar",
    "scheduleVersionHierarchy": "Jerarquía de versiones del programa",
    "eventBlockHierarchy": "Jerarquía de bloques de eventos",
    "venueRunSheets": "Venue Run Sheets (DCAS)",
    "timezone": "Zona horaria",
    "dayStartTime": "Hora de inicio de cada día",
    "dayEndTime": "Hora de finalización de cada día",
    "projectStartDate": "Fecha de inicio del proyecto",
    "projectEndDate": "Fecha de finalización del proyecto",
    "projectZeroDate": "Día 0 del proyecto",
    "eventBlockTitleTop": "Bloques de eventos de calendario de nivel superior",
    "eventBlockTitleSecond": "Bloques de eventos de calendario de segundo nivel",
    "eventBlockTitleThird": "Bloque de eventos de calendario de tercer nivel",
    "eventBlockTitleDefault": "Bloque de eventos de calendario de nivel",
    "eventBlockTypeName": "Nombre del tipo de bloque de eventos",
    "eventBlockApiSingle": "Nombre de API: singular",
    "eventBlockApiPlural": "Nombre de API en plural",
    "eventBlockAllowedVenueTypes": "Tipos de lugares permitidos",
    "eventBlockRelativeTypes": "Puede ser relativo a los tipos",
    "eventBlockSummaryText": "Atributos del bloque de eventos secundario para usar en el resumen",
    "eventBlockDCAS": "Se puede crear dentro del DCAS",
    "eventBlockCustomerIdentifier": "Identificador de cliente",
    "clusterVenueLocationTemplateTitle": "Plantilla de ubicación de la sede del clúster",
    "mainVenueLocationTemplateTitle": "Plantilla de ubicación de la sede principal",
    "subVenueLocationTemplateTitle": "Plantilla de ubicación de la subsede",
    "enableClusters": "Habilitar clústeres",
    "editVenues": "Edita sedes",
    "venueLocations": "Ubicaciones de las sedes",
    "venueLocationTypeName": "Nombre del tipo de ubicación del lugar",
    "attributes": "Atributos",
    "scheduleVersionTopLevelTitle": "Versión de programación de nivel superior",
    "scheduleVersionSecondLevelTitle": "Versión de programación de segundo nivel",
    "scheduleVersionLevelTitle": "Versión de programación de niveles",
    "scheduleVersionName": "Nombre de la versión del programa",
    "problems": "Hay {{ problemCount }} problemas con la configuración de programación enviada",
    "dcasEventBlock": "Bloque de eventos para Run Sheet",
    "dcasEventBlockQuestion": "Habilite el bloque de eventos solo en la hoja de ejecución",
    "dcasEventBlockCalendar": "Bloques de eventos para usar",
    "dcasEventBlockAttributes": "Atributos de la hoja de ejecución",
    "dcasEnableDone": "Marque las actividades con la palabra «Listo»",
    "calendarLevel": {
      "0": "sesión",
      "1": "elemento programado",
      "activity": "actividad"
    }
  }
}